import { render } from "./fileStatistics.vue?vue&type=template&id=63924297&scoped=true"
import script from "./fileStatistics.vue?vue&type=script&lang=js"
export * from "./fileStatistics.vue?vue&type=script&lang=js"

import "./fileStatistics.vue?vue&type=style&index=0&id=63924297&scoped=true&lang=scss"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63924297"]])

export default __exports__